export const FEATURE_FLAGS_QUERY_KEY = "feature-flags";
